import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import SmallButton from "@ats/src/components/shared/SmallButton";
import { PlatoChip } from "@ats/src/components/shared/PlatoMark";

// Handoff card at the bottom of Plan & billing pointing admins to the Plato AI billing area.
interface AiCreditsCalloutProps {
  onClickManage: () => void;
}

const AiCreditsCallout: React.FC<AiCreditsCalloutProps> = ({ onClickManage }) => {
  return (
    <Styled.Callout>
      <Styled.Main>
        <PlatoChip size={40} radius={10} />
        <div>
          <Styled.Title>AI credits</Styled.Title>
          <Styled.Body>Additional AI credits are billed separately from your plan.</Styled.Body>
        </div>
      </Styled.Main>
      <SmallButton styleType="secondary" onClick={onClickManage}>
        Manage AI credits
      </SmallButton>
    </Styled.Callout>
  );
};

export default AiCreditsCallout;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Callout = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AiCreditsCallout;
    ${[t.rounded.md, t.p(5), t.mt(3), t.mb(2)]}
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${t.spacing[4]};
    width: 100%;
    border: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
    background-color: ${t.dark ? t.color.gray[800] : t.color.white};
  `;
});

Styled.Main = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AiCreditsCallout_Main;
    display: flex;
    align-items: center;
    gap: ${t.spacing[3]};
  `;
});

Styled.Title = styled.h3((props) => {
  const t: any = props.theme;
  return css`
    label: AiCreditsCallout_Title;
    ${[t.text.sm, t.text.bold]}
    color: ${t.dark ? t.color.gray[100] : t.color.black};
    line-height: 1.3;
  `;
});

Styled.Body = styled.p((props) => {
  const t: any = props.theme;
  return css`
    label: AiCreditsCallout_Body;
    ${[t.text.sm, t.mt("px")]}
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    line-height: 1.4;
  `;
});
